/**
 * Device-level helpers of the annotation engine without React (re-exported by useSheetAnnotations,
 * the public entry): used from the offline manager, the wipe and logout code, which must not pull
 * in React modules.
 */
import { engine } from './engine/engine';

/** Unsent annotation and layer changes of `userId` on this device (incl. rejected ones). */
export function pendingAnnotationOps(userId: string): Promise<number> {
  return engine.pendingCount(userId).catch(() => 0);
}

/** Sends the signed-in user's queued annotation changes now; resolves when done or stopped. */
export function flushAnnotationOps(): Promise<void> {
  return engine.flushAll().catch(() => undefined);
}

/** Removes local layers/annotations (and queued changes) of these sheets; false when the stored copies remain. */
export function purgeSheetAnnotations(sheetFileIds: readonly string[]): Promise<boolean> {
  return engine.purgeSheets(sheetFileIds).catch(() => false);
}

/** Removes the local copies of every sheet `userId`'s manifest does not list (see engine.purgeSheetsNotIn). */
export function purgeAnnotationsNotIn(userId: string, visibleSheetIds: Iterable<string>): Promise<boolean> {
  return engine.purgeSheetsNotIn(userId, visibleSheetIds).catch(() => false);
}

/** Session revoked: drops every layer pulled from the server (memory and IndexedDB), keeps unsent changes. */
export function forgetPulledAnnotations(): Promise<void> {
  return engine.forgetPulled().catch(() => undefined);
}

/** Installs the sync triggers and sends anything left from an earlier session (call once when signed in). */
export function startAnnotationSync(): void {
  engine.boot();
  void engine.flushAll();
}
